/**
 * 产品列表页面
 */

import { useLocation, useNavigate } from "react-router-dom";
import { ProductListContent } from "../components/ProductListContent";
import type { ProductListVO } from "@ifa/utils";

export function ProductList() {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectMode, from, productType, companyCode } = (location.state as any) || {};

  const handleSelect = (product: ProductListVO) => {
    if (selectMode) {
      if (from) {
        navigate(from, { state: { ...location.state, selectedProduct: product } });
      } else {
        navigate(-1);
      }
    } else {
      navigate(`/products/${product.productCode}/info`);
    }
  };

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <ProductListContent
      selectMode={selectMode}
      onSelect={handleSelect}
      onClose={handleClose}
      productType={productType}
      companyCode={companyCode}
    />
  );
}
